<template>
    <div class="m15" ref="body" style="page-break-before: always;">
        <hr v-if="exibe === true"/>
        <h4 class="simulator-title loaded" v-if="exibe === true">Educação dos Filhos</h4>
        <saudacao :cliente.sync="cliente.pessoa" ref="saudacao" class="saudacao"/>
        <div class="row" v-if="exibe === true">
            <div class="col l3"></div>
            <div class="col l6 s12 chart-container">
                <div class="chart-overflow">
                    <apexcharts
                        ref="barchart"
                        type="bar"
                        :options="options"
                        :series="options.series"
                        ></apexcharts>
                </div>
                <div class="block" style="margin-top:15px;margin-bottom:15px;">
                    <div align="center">Educação dos Filhos</div>
                    <div class="total" align="center">Total: {{this.saldo}}</div>
                </div>
            </div>
            <div class="col l3"></div>
        </div>
        <div class="row" v-if="exibe === true">
            <div class="col l12 s12">
                <div class="row">
                <div class="texto" style="text-align:justify">
                    A educação de nossos filhos talvez seja um dos nossos maiores patrimônios, nosso
                    maior desafio, prepará-los para profissões que talvez ainda nem existam.
                </div>
                </div>
                <div class="row">
                    <div class="texto" style="text-align:justify">
                        No levantamento realizado,  para a garantia de educar os seus filhos, protegendo esse sonho que os darão a capacitação necessária para os desafios do mundo competitivo que vivemos, uma cobertura de {{ saldo }} em capital segurado é a melhor estratégia.
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ApexCharts from 'apexcharts'
    import VueApexchar from 'vue-apexcharts'
    import { get } from "@/helpers/api";
    import { utils } from "../relatorios/mixins/index";
    import Saudacao from './Saudacao'
    export default {
        name:'EducacaoFilhos',
        mixins: [utils],
        components: {
            'apexcharts': VueApexchar,
            Saudacao
        },
        props: {
            cliente: {
                type: Object,
                default: null
            },
            empresa_selecionada: {
                type: Object,
                default: null
            },
            resumo: Object,
        },
        data () {
            return {
                db: [],
                options: {},
                image:null,
                saldo: null,
                exibe: false,
                totalCobertura: null,
                totalCobertura_extenso: null,

                titulo: 'Educação dos Filhos'
            }
        },
        methods:{
            async plot()
            {

                if (! this.$refs.barchart) return '';


                await this.$refs.barchart.chart.dataURI().then(uri => {
                    this.image = uri || 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/x8AAwMCAO+ip1sAAAAASUVORK5CYII='
                });

                if(this.exibe === true){
                return `<div class="m15 page_logo" ref="body" id="educacao" style="page-break-before: always;">
                        <div class="site"></div>
                        <h4 class="simulator-title loaded">${this.titulo}</h4>
                         ${this.$refs.saudacao.plot()}
                        <div class="grafico">
                        <div class="row" style="padding-top: 200px;">

                                <img src="${this.image}" />
                                <div class="block">
                                    <div align="center">Educação dos Filhos</div>
                                    <div class="total" align="center">Total: ${this.saldo}</div>
                                </div>

                        </div>
                        </div>
                        <div class="row" style="padding-top: 200px;">
                            <table>
                                <tr>
                                    <td width="100%" style="vertical-align: top;">
                                        <p style="font-size:18px;padding-bottom:30px;">
                                            A educação de nossos filhos talvez seja um dos nossos maiores patrimônios, nosso
                                            maior desafio, prepará-los para profissões que talvez ainda nem existam.
                                            <br><br>
                                            No levantamento realizado, para a garantia de educar os seus filhos, protegendo
                                            esse sonho, que os darão a capacitação necessária para os desafios do mundo
                                            competitivo que vivemos, uma cobertura de ${this.saldo} em capital segurado é a
                                            melhor estratégia.
                                        </p>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>`;
                }else{
                    return ''
                }
            },
            jsonToObject(j){
                if(j != undefined)
                return Object.keys(j).map(function(_) { return j[_]; })
            },
            readyData(params){

                const that = this;
                const total = params[params.length - 1].total

                const porcentagens = params.map(item => {
                    return Math.max(5, (item.total / total) * 100)
                });



                this.options = {
                    chart: {
                        width: "100%",
                        height: 380,
                        type: 'bar',
                        animations: {
                            enabled: false
                        },
                        stacked: true,
                        //stackType: '100%',
                        toolbar:{
                            show:false,
                        },
                        zoom: {
                            enabled: false
                        }
                    },
                    plotOptions: {
                        bar: {
                            horizontal: false,
                            columnWidth: '30%',
                            distributed: true,
                            dataLabels: {
                                position: 'top',
                            },
                            //endingShape: 'rounded'
                        }
                    },
                    dataLabels: {
                        enabled: true,
                        //textAnchor: 'middle',
                        style: {
                            colors: ['#000']
                        },
                        formatter: function (y, options) {

                            const valor = params[options.dataPointIndex].total;

                            return that.$options.filters.dinheiro(valor);
                        },
                        offsetY: -20,
                    },
                    series: [
                        {
                            name: 'Total',
                            data: porcentagens,
                            // data: params.map(item => item.total ? item.total: 0 )
                        }
                    ],
                    grid: {
                        row: {
                          colors: ['#fff', '#f2f2f2']
                        }
                    },
                    colors: ['#ffc059','#ff6565','#708bcc','#4ad991','#52dfec','#a3a0fb'],
                    xaxis: {
                        categories: params.map(item => item.nome),
                        //floating: true,
                        labels: {
                            show: true,
                            rotate: -45,
                            rotateAlways: true,
                            minHeight: 100,
                            maxHeight: 180,
                            style: {
                                fontSize: '12px'
                            }
                            // formatter: function(val){
                            //     return 'R$ '+val
                            // }
                        }
                    },
                    yaxis: {
                        show: true,
                        showAlways: true,
                        tickAmount: params.length,
                        labels: {
                            show: false,
                            align: 'right',
                            style: {
                                fontSize: '12px',
                                fontFamily: 'Helvetica, Arial, sans-serif',
                                cssClass: 'apexcharts-yaxis-label',
                            },
                            formatter: function (y) {
                                return that.$options.filters.dinheiro(y * (total / 100));

                            }
                        },

                    },
                    legend: {
                        position: 'right',
                        fontSize: '14px',
                        itemMargin: {
                            horizontal: 8,
                            vertical: 3
                        },
                    },
                    theme: {
                        mode: 'light',
                        palette: 'palette1'
                    },
                    tooltip:{
                        enabled: true,
                        theme:'light',
                        shared: true,
                        intersect: false,
                        x: {
                            show: true
                        },
                        y: {
                            formatter: function (y, options) {
                                const valor = params[options.dataPointIndex].total;

                                return that.$options.filters.dinheiro(valor);

                            }
                        }

                    },
                    responsive: [{
                        breakpoint: 1000,
                        options: {
                            legend: {
                                position: "bottom"
                            }
                        }
                    },
                    {
                        breakpoint: 380,
                        options:{
                            plotOptions: {
                                bar: {
                                    horizontal: false
                                }
                            },
                            legend: {
                                position: "top"
                            }
                        }
                    }]
                }
            },
            async getData(){

                const resumo = this.resumo;

                const totalResumo = this.resumo.necessidade_segurado || 0;

                this.totalCobertura = this.real(totalResumo)

                const { educacao_filhos } = this.cliente;

                const educacaoFilho = async (educacao_filho_id) => {
                    let { data: { result : {data: filho } } } = await get(`educacao-filho/${educacao_filho_id}`);
                    const f = {
                        'nome': filho.nome,
                        'despesas': filho.despesas.map(item => parseFloat(item.total).toFixed(2)),
                        'total': filho.despesas.map(item =>  item.total).reduce((a,b)=> parseFloat(a) + parseFloat(b), 0)
                    }
                    return f
                }


               let data = []


                await Promise.all(educacao_filhos.map(async (filho) => {
                    const resultado = await educacaoFilho(filho.educacao_filho_id);
                    data.push(resultado);
                    return resultado;
                }));

                const total = data.map(item =>{ return item.total}).reduce((a,b)=> parseFloat(a) + parseFloat(b), 0)

                data.push({nome:'Investimento Total',despesas:0,total:total});

                this.saldo = this.real(total)
                this.totalCobertura_extenso = this.currency(totalResumo)

                if(data.length > 0 && this.saldo !== 'R$ 0,00'){
                    this.exibe = true
                    this.db.push(data);
                    this.readyData(data, totalResumo)
                }


                return this.real(total)
            }
        },
        mounted () {
            this.getData()
        }
    }
</script>

<style lang="scss" scoped>
@import "../relatorios/Simulador.scss";

.graph{
    text-align: center;
}
.texto {
    margin-top: 15px;
    margin-bottom: 15px;
}
.m5 {
    margin-top: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/graficos-simulador/EducacaoFilhos.vue